module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-ring"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), (_vm.paymentInitiateLoader) ? _c('p', {
    staticClass: "payment-loader-msg"
  }, [_vm._v("Payment Processing...")]) : _vm._e(), _vm._v(" "), (_vm.paymentInitiateLoader) ? _c('p', {
    staticClass: "payment-notify-msg"
  }, [_vm._v("Do not close or refresh this page")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51b39ef6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/loader.vue
// module id = 1001
// module chunks = 113